window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    cartCount: '[data-cart-count]',
    cartCountBubble: '[data-cart-count-bubble]',
    cartDiscount: '[data-cart-discount]',
    cartDiscountTitle: '[data-cart-discount-title]',
    cartDiscountAmount: '[data-cart-discount-amount]',
    cartDiscountWrapper: '[data-cart-discount-wrapper]',
    cartErrorMessage: '[data-cart-error-message]',
    cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
    cartItem: '[data-cart-item]',
    cartItemDetails: '[data-cart-item-details]',
    cartItemDiscount: '[data-cart-item-discount]',
    cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
    cartItemDiscountTitle: '[data-cart-item-discount-title]',
    cartItemDiscountAmount: '[data-cart-item-discount-amount]',
    cartItemDiscountList: '[data-cart-item-discount-list]',
    cartItemFinalPrice: '[data-cart-item-final-price]',
    cartItemImage: '[data-cart-item-image]',
    cartItemLinePrice: '[data-cart-item-line-price]',
    cartItemOriginalPrice: '[data-cart-item-original-price]',
    cartItemPrice: '[data-cart-item-price]',
    cartItemPriceList: '[data-cart-item-price-list]',
    cartItemProperty: '[data-cart-item-property]',
    cartItemPropertyName: '[data-cart-item-property-name]',
    cartItemPropertyValue: '[data-cart-item-property-value]',
    cartItemExtrasWrapper: '[data-cart-item-extras-wrapper]',
    cartItemNoExtras: '[data-cart-item-extras-zero]',
    cartItemExtra: '[data-cart-item-extra]',
    cartItemExtraSwarovski: '[data-cart-item-extra-free-swarovski]',
    cartItemExtraName: '[data-cart-item-extra-name]',
    cartItemExtraPrice: '[data-cart-item-extra-price]',
    cartItemExtrasPriceWrapper: '[data-cart-item-extras-price-wrapper]',
    cartItemExtrasPrice: '[data-cart-item-extras-price]',
    cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
    cartItemRegularPrice: '[data-cart-item-regular-price]',
    cartItemTitle: '[data-cart-item-title]',
    cartItemOption: '[data-cart-item-option]',
    cartLineItems: '[data-cart-line-items]',
    cartNote: '[data-cart-notes]',
    cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
    cartQuantityErrorMessageWrapper:
      '[data-cart-quantity-error-message-wrapper]',
    cartRemove: '[data-cart-remove]',
    cartStatus: '[data-cart-status]',
    cartSubtotal: '[data-cart-subtotal]',
    cartSubtotalDiscounted: '[data-cart-subtotal-discounted]',
    cartTableCell: '[data-cart-table-cell]',
    cartWrapper: '[data-cart-wrapper]',
    emptyPageContent: '[data-empty-page-content]',
    quantityInput: '[data-quantity-input]',
    quantityInputMobile: '[data-quantity-input-mobile]',
    quantityInputDesktop: '[data-quantity-input-desktop]',
    quantityLabelMobile: '[data-quantity-label-mobile]',
    quantityLabelDesktop: '[data-quantity-label-desktop]',
    inputQty: '[data-quantity-input]',
    thumbnails: '.cart__image',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]',
    unitPriceGroup: '[data-unit-price-group]',
    autoClearCart: '[data-autoremove-item-by-key]',
  };

  var classes = {
    cartNoCookies: 'cart--no-cookies',
    cartRemovedProduct: 'cart__removed-product',
    thumbnails: 'cart__image',
    hide: 'hide',
    inputError: 'input--error'
  };

  var attributes = {
    cartItemIndex: 'data-cart-item-index',
    cartItemSelectIndex: 'data-cart-item-select-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemUrl: 'data-cart-item-url',
    cartItemHash: 'data-cart-item-hash',
    quantityItem: 'data-quantity-item',
    autoClearCartKey: 'data-autoremove-item-by-key',
  };

  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

  // "Updating your cart…" loader from sections/cart-template.liquid (shown while a star is removed)
  function hideCartLoader() {
    if (window.cartUpgradeLoader) window.cartUpgradeLoader.hide();
  }

  function Cart(container) {
    this.container = container;
    this.thumbnails = this.container.querySelectorAll(selectors.thumbnails);
    this.quantityInputs = this.container.querySelectorAll(selectors.inputQty);

    this.ajaxEnabled = this.container.getAttribute('data-ajax-enabled');

    this._handleInputQty = theme.Helpers.debounce(
      this._handleInputQty.bind(this),
      500
    );
    this.setQuantityFormControllers = this.setQuantityFormControllers.bind(
      this
    );
    this._onNoteChange = this._onNoteChange.bind(this);
    this._onRemoveItem = this._onRemoveItem.bind(this);





    this.container.addEventListener('click', this._handleThumbnailClick);
    this.container.addEventListener('change', this._handleInputQty);

    this.mql = window.matchMedia(mediumUpQuery);
    this.mql.addListener(this.setQuantityFormControllers);

    this.setQuantityFormControllers();

    if (this.ajaxEnabled) {

     
      console.log('[Cart] Adding cart:refresh listener', this);

document.addEventListener('cart:refresh', (event) => {
  console.log('[Cart] cart:refresh triggered', event, this);
  this._fetchUpdatedCartItems();
});

      /**
       * Because the entire cart is recreated when a cart item is updated,
       * we cannot cache the elements in the cart. Instead, we add the event
       * listeners on the cart's container to allow us to retain the event
       * listeners after rebuilding the cart when an item is updated.
       */
      this.container.addEventListener('click', this._onRemoveItem);
      this.container.addEventListener('change', this._onNoteChange);

      this._setupCartTemplates();
    }

    if (window.cart.product && document.querySelector('[data-upbrightness]')) {
      this.upgradeBrightness.init(this);
      console.log('upgradeBrightness Initialized');
    }

    /* this.discount.init(this);  */
  }

  Cart.prototype = Object.assign({}, Cart.prototype, {
    _setupCartTemplates: function() {
      var cartItem = this.container.querySelector(selectors.cartItem);
      if (!cartItem) return;

      

      this.itemTemplate = this.container
        .querySelector(selectors.cartItem)
        .cloneNode(true);

      this.itemDiscountTemplate = this.itemTemplate
        .querySelector(selectors.cartItemDiscount)
        .cloneNode(true);

      this.cartDiscountTemplate = this.container
        .querySelector(selectors.cartDiscount)
        .cloneNode(true);

      this.itemPriceListTemplate = this.itemTemplate
        .querySelector(selectors.cartItemPriceList)
        .cloneNode(true);

      this.itemOptionTemplate = this.itemTemplate
        .querySelector(selectors.cartItemOption)
        .cloneNode(true);

      this.itemPropertyTemplate = this.itemTemplate
        .querySelector(selectors.cartItemProperty)
        .cloneNode(true);

      this.itemExtraTemplate = this.itemTemplate
        .querySelector(selectors.cartItemExtra)
        .cloneNode(true);

      this.autoClearCart();
    },

    autoClearCart: function () {
      var clearItems = document.querySelectorAll(selectors.autoClearCart);
      if (clearItems.length > 0) {
        document.body.classList.add('loading');
        var data = { updates: {} };
        clearItems.forEach(function (item) {
          var key = item.getAttribute(attributes.autoClearCartKey);
          data.updates[key] = 0;
        });

        var request = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;'
          },
          body: JSON.stringify(data)
        };

        var lineItem = this.container.querySelector(selectors.cartItem);
        this._updateJsRequest(request, function (state) {
          
          document.body.classList.remove('loading');
        }.bind(this));
      }
    },

    _handleInputQty: function(evt) {
      if (!evt.target.hasAttribute('data-quantity-input')) return;

      var input = evt.target;
      var itemElement = input.closest(selectors.cartItem);

      var itemIndex = Number(input.getAttribute('data-quantity-item'));

      var itemQtyInputs = this.container.querySelectorAll(
        "[data-quantity-item='" + itemIndex + "']"
      );

      var value = parseInt(input.value);

      var isValidValue = !(value < 0 || isNaN(value));

      itemQtyInputs.forEach(function(element) {
        element.value = value;
      });

      this._hideCartError();
      this._hideQuantityErrorMessage();

      if (!isValidValue) {
        this._showQuantityErrorMessages(itemElement);
        return;
      }

      if (isValidValue && this.ajaxEnabled) {
        this._updateItemQuantity(itemIndex, itemElement, itemQtyInputs, value);
      }
    },

    _fetchUpdatedCartItems: function() {

      


      // Use the real section id (e.g. template--123__main) so the re-render keeps the
      // template's saved settings; 'cart-template' alone renders with schema defaults.
      const sectionId = window.cartSectionId || 'cart-template';
      return fetch(window.Shopify.routes.root + 'cart?sections=' + sectionId)
        .then((response) => response.json())
        .then((data) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data[sectionId], 'text/html');
          const newCartItems = doc.querySelector('cart-items');
  
          if (newCartItems) {
            document.querySelector('cart-items').innerHTML = newCartItems.innerHTML;
          }
          // keep the header count in sync (it was never updated after a remove)
          if (window.updateCartCount) {
            fetch(window.Shopify.routes.root + 'cart.js')
              .then((r) => r.json())
              .then((cart) => window.updateCartCount(cart))
              .catch(() => {});
          }
        })
        .catch((error) => {
          console.error('Error fetching updated cart items:', error);
        });
    },

    _updateItemQuantity: function(
      itemIndex,
      itemElement,
      itemQtyInputs,
      value
    ) {
      var key = itemElement.getAttribute(attributes.cartItemKey);
      var index = Number(itemElement.getAttribute(attributes.cartItemIndex));

      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          line: index,
          quantity: value
        })
      };

      fetch('/cart/change.js', request)
        .then(function(response) {
          return response.json();
        })
        .then(
          function(state) {
            this._setCartCountBubble(state);

            if (!state.item_count) {
              this._emptyCart();
              return;
            }

           

            if (!value) {
              this._showRemoveMessage(itemElement.cloneNode(true));
              return;
            }
            console.log("Updating item with key: " + key);

            var lineItem = document.querySelector(
              "[data-cart-item-key='" + key + "']"
            );
            console.log("Found line item: ", lineItem);

            var item = this.getItem(key, state);

            var inputSelector = this.mql.matches
              ? selectors.quantityInputDesktop
              : selectors.quantityInputMobile;

            this._updateLiveRegion(item);

            if (!lineItem) return;
            lineItem.querySelector(inputSelector).focus();
          }.bind(this)
        )
        .catch(
          function() {
            this._showCartError(null);
          }.bind(this)
        );
    },

    getItem: function(key, state) {
      return state.items.find(function(item) {
        return item.key === key;
      });
    },

    _liveRegionText: function(item) {
      // Dummy content for live region
      var liveRegionText =
        theme.strings.update +
        ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';

      // Update Quantity
      liveRegionText = liveRegionText
        .replace('[QuantityLabel]', theme.strings.quantity)
        .replace('[Quantity]', item.quantity);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        item.original_line_price,
        theme.moneyFormat
      );
      var discountLabel = '';
      var discountPrice = '';
      var discountInformation = '';

      if (item.original_line_price > item.final_line_price) {
        regularLabel = theme.strings.regularTotal;

        discountLabel = theme.strings.discountedTotal;
        discountPrice = theme.Currency.formatMoney(
          item.final_line_price,
          theme.moneyFormat
        );

        discountInformation = theme.strings.priceColumn;
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[DiscountedPrice]', discountLabel)
        .replace('[$]', discountPrice)
        .replace('[PriceInformation]', discountInformation)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(item) {
      if (!item) return;

      var liveRegion = this.container.querySelector(selectors.cartStatus);

      liveRegion.textContent = this._liveRegionText(item);
      liveRegion.setAttribute('aria-hidden', false);

      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },



    _createCartDiscountList: function(cart) {
      return cart.cart_level_discount_applications.map(
        function(discount) {
          var discountNode = this.cartDiscountTemplate.cloneNode(true);

          discountNode.querySelector(selectors.cartDiscountTitle).textContent =
            discount.title;

          discountNode.querySelector(
            selectors.cartDiscountAmount
          ).textContent = theme.Currency.formatMoney(
            discount.total_allocated_amount,
            theme.moneyFormat
          );

          return discountNode;
        }.bind(this)
      );
    },

    _createLineItemList: function(state) {
      return state.items.filter(function (item) {
        return typeof item.properties._parent === 'undefined';
      }).map(
          function (item, index) {
            var itemNode = this.itemTemplate.cloneNode(true);
            console.log(itemNode);
            var itemPriceList = this.itemPriceListTemplate.cloneNode(true);

            var originalIndex = state.items.indexOf(item);
            this._setLineItemAttributes(itemNode, item, originalIndex, index);
            this._setLineItemImage(itemNode, item.featured_image);

            var cartItemTitles = itemNode.querySelectorAll(selectors.cartItemTitle);
            cartItemTitles.forEach(function (cartItemTitle) {
              var titleSuffix = '';
              if (item.properties._hash && !item.properties._parent) {
                if (item.variant_options.length === 1) {
                  titleSuffix = ' - ' + item.variant_options[0].split('-')[0].trim();
                }
              }
              cartItemTitle.textContent = item.product_title + titleSuffix;
              cartItemTitle.setAttribute('href', item.url);
            });



   

        

            this._setItemRemove(itemNode, item.title);

            itemPriceList.innerHTML = this._createItemPrice(
                item.original_price,
                item.final_price
            ).outerHTML;

            if (item.unit_price_measurement) {
              itemPriceList.appendChild(
                  this._createUnitPrice(
                      item.unit_price,
                      item.unit_price_measurement
                  )
              );
            }

            this._setItemPrice(itemNode, itemPriceList);

            var itemDiscountList = this._createItemDiscountList(item);
            this._setItemDiscountList(itemNode, itemDiscountList);
            this._setQuantityInputs(itemNode, item, index);

            var itemLinePrice = this._createItemPrice(
                item.original_line_price,
                item.final_line_price
            );

            this._setItemLinePrice(itemNode, itemLinePrice);

            return itemNode;
          }.bind(this)
      );
    },


    _setItemDiscountList: function(item, discountList) {
      var itemDiscountList = item.querySelector(selectors.cartItemDiscountList);

      if (discountList.length === 0) {
        itemDiscountList.innerHTML = '';
        itemDiscountList.classList.add(classes.hide);
      } else {
        itemDiscountList.innerHTML = discountList.reduce(function(
          result,
          element
        ) {
          return result + element.outerHTML;
        },
        '');

        itemDiscountList.classList.remove(classes.hide);
      }
    },

    _setItemRemove: function(item, title) {
      item
        .querySelector(selectors.cartRemove)
        .setAttribute(
          'aria-label',
          theme.strings.removeLabel.replace('[product]', title)
        );
    },

    _setQuantityInputs: function(itemNode, item, index) {
      var mobileInput = itemNode.querySelector(selectors.quantityInputMobile);
      var desktopInput = itemNode.querySelector(selectors.quantityInputDesktop);

      if (!mobileInput || !desktopInput) {
        return;
      }

      mobileInput.setAttribute('id', 'updates_' + item.key);
      desktopInput.setAttribute('id', 'updates_large_' + item.key);

      [mobileInput, desktopInput].forEach(function(element) {
        element.setAttribute(attributes.quantityItem, index + 1);
        element.value = item.quantity;
      });

      itemNode
        .querySelector(selectors.quantityLabelMobile)
        .setAttribute('for', 'updates_' + item.key);

      itemNode
        .querySelector(selectors.quantityLabelDesktop)
        .setAttribute('for', 'updates_large_' + item.key);
    },

    setQuantityFormControllers: function() {
      var desktopQuantityInputs = document.querySelectorAll(
        selectors.quantityInputDesktop
      );

      var mobileQuantityInputs = document.querySelectorAll(
        selectors.quantityInputMobile
      );

      if (this.mql.matches) {
        addNameAttribute(desktopQuantityInputs);
        removeNameAttribute(mobileQuantityInputs);
      } else {
        addNameAttribute(mobileQuantityInputs);
        removeNameAttribute(desktopQuantityInputs);
      }

      function addNameAttribute(inputs) {
        inputs.forEach(function(element) {
          element.setAttribute('name', 'updates[]');
        });
      }

      function removeNameAttribute(inputs) {
        inputs.forEach(function(element) {
          element.removeAttribute('name');
        });
      }
    },





    _createItemDiscountList: function(item) {
      // the brightness upgrade discount has its own note row in the star card. Its title is in
      // the buyer's language, so it is recognised by its amount: the signed amount in
      // _upgrade_discount ("<cents>.<currency>.…"), capped at the line (same as cart-item-card.liquid)
      // Function discounts come with a blank discount_application.type, so only codes are ruled out
      var upgradeToken = item.properties && item.properties._upgrade_discount;
      var upgradeCents = upgradeToken ? parseInt(String(upgradeToken).split('.')[0], 10) : NaN;
      return item.line_level_discount_allocations.filter(function(discount) {
        var isBrightnessUpgrade =
          discount.discount_application.type !== 'discount_code' &&
          (discount.amount === upgradeCents || discount.amount === item.original_line_price);
        return !(upgradeToken && isBrightnessUpgrade);
      }).map(
        function(discount) {
          var discountNode = this.itemDiscountTemplate.cloneNode(true);

          discountNode.querySelector(
            selectors.cartItemDiscountTitle
          ).textContent = discount.discount_application.title;

          discountNode.querySelector(
            selectors.cartItemDiscountAmount
          ).textContent = theme.Currency.formatMoney(
            discount.amount,
            theme.moneyFormat
          );

          return discountNode;
        }.bind(this)
      );
    },

    _showQuantityErrorMessages: function(itemElement) {
      itemElement
        .querySelectorAll(selectors.cartQuantityErrorMessage)
        .forEach(function(element) {
          element.textContent = theme.strings.quantityMinimumMessage;
        });

      itemElement
        .querySelectorAll(selectors.cartQuantityErrorMessageWrapper)
        .forEach(function(element) {
          element.classList.remove(classes.hide);
        });

      itemElement
        .querySelectorAll(selectors.inputQty)
        .forEach(function(element) {
          element.classList.add(classes.inputError);
          element.focus();
        });
    },

    _hideQuantityErrorMessage: function() {
      var errorMessages = document.querySelectorAll(
        selectors.cartQuantityErrorMessageWrapper
      );

      errorMessages.forEach(function(element) {
        element.classList.add(classes.hide);

        element.querySelector(selectors.cartQuantityErrorMessage).textContent =
          '';
      });

      this.container
        .querySelectorAll(selectors.inputQty)
        .forEach(function(element) {
          element.classList.remove(classes.inputError);
        });
    },



    _onNoteChange: function(evt) {
      if (!evt.target.hasAttribute('data-cart-notes')) return;

      var note = evt.target.value;
      this._hideCartError();
      this._hideQuantityErrorMessage();

      var headers = new Headers({ 'Content-Type': 'application/json' });

      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ note: note })
      };

      fetch('/cart/update.js', request).catch(
        function() {
          this._showCartError(evt.target);
        }.bind(this)
      );
    },

    _showCartError: function(elementToFocus) {
      console.trace();
      document.querySelector(selectors.cartErrorMessage).textContent =
        theme.strings.cartError;

      document
        .querySelector(selectors.cartErrorMessageWrapper)
        .classList.remove(classes.hide);

      if (!elementToFocus) return;
      elementToFocus.focus();
    },

    _hideCartError: function() {
      document
        .querySelector(selectors.cartErrorMessageWrapper)
        .classList.add(classes.hide);
      document.querySelector(selectors.cartErrorMessage).textContent = '';
    },

    _onRemoveItem: function(evt) {
      if (!evt.target.hasAttribute('data-cart-remove')) return;

      evt.preventDefault();
      var lineItem = evt.target.closest(selectors.cartItem);
      var index = Number(lineItem.getAttribute(attributes.cartItemIndex));

      
      // Add the removing class to trigger the fade-out animation
    lineItem.classList.add('cart-item-removing');

    // Add the fade-out class after a short delay
    setTimeout(function() {
      lineItem.classList.add('cart-item-removed');
    }, 1000);

      this._hideCartError();
      if (window.cartUpgradeLoader) window.cartUpgradeLoader.show('cart');

      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          line: index,
          quantity: 0
        })
      };

      this._changeJsRequest(request, function (state) {
        var parentHash = lineItem.getAttribute(attributes.cartItemHash);
        var childItems = state.items.filter(function (item) {
          return item.properties._parent === parentHash
        });
        if (childItems.length > 0) {
          var data = { updates: {} };
          childItems.forEach(function (item) {
            data.updates[item.key] = 0;
          });

          var request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json;'
            },
            body: JSON.stringify(data)
          };

          this._updateJsRequest(request, function (state) {
            document.body.classList.remove('loading');
            setTimeout(function() {
              this._fetchUpdatedCartItems().then(hideCartLoader);
              console.log('Fetch inside updateJsRequest 1')
            }.bind(this), 500);
            
          }.bind(this));
        } else {
          document.body.classList.remove('loading');
          setTimeout(function() {
            this._fetchUpdatedCartItems().then(hideCartLoader);
            console.log('Fetch change JS request')
          }.bind(this), 500);
          

        }
        
      }.bind(this));
    },



    _changeJsRequest: function (request, cb) {
      fetch('/cart/change.js', request)
          .then(function (response) {
            return response.json();
          })
          .then(
              function (state) {
                setTimeout(function() {
                  this._fetchUpdatedCartItems();
                  console.log('Fetch inside changeJsRequest 1')
                }.bind(this), 500);
                cb(state);
              }.bind(this)
          )
          .catch(
              function (err) {
                console.log(err);
                hideCartLoader();
                this._showCartError(null);
              }.bind(this)
          );
    },

    _updateJsRequest: function (request, cb) {
      
      fetch('/cart/update.js', request)
          .then(function (response) {
            return response.json();
          })
          .then(
              function (state) {
                cb(state);
              }.bind(this)
          )
          .catch(
              function (err) {
                console.log(err);
                hideCartLoader();
                this._showCartError(null);
              }.bind(this)
          );
    },

    _removeItemByLine: function (line) {

    },

    _showRemoveMessage: function(lineItem) {
      var index = lineItem.getAttribute(attributes.cartItemSelectIndex);
      var removeMessage = this._getRemoveMessage(lineItem);

      if (index - 1 === 0) {
        this.container
          .querySelector('[data-cart-item-index="1"]')
          .insertAdjacentHTML('beforebegin', removeMessage.outerHTML);
      } else {
        this.container
          .querySelector("[data-cart-item-select-index='" + (index - 1) + "']")
          .insertAdjacentHTML('afterend', removeMessage.outerHTML);
      }

      this.container.querySelector('[data-removed-item-row]').focus();
    },

    _getRemoveMessage: function(lineItem) {
      var formattedMessage = this._formatRemoveMessage(lineItem);

      lineItem.removeAttribute('class');
      lineItem.classList.add(classes.cartRemovedProduct);
      lineItem.setAttribute('colspan', '4');
      lineItem.innerHTML = formattedMessage;

      lineItem.setAttribute('role', 'alert');
      lineItem.setAttribute('tabindex', '-1');
      lineItem.setAttribute('data-removed-item-row', true);

      return lineItem;
    },

    _formatRemoveMessage: function(lineItem) {
      var quantity = lineItem.getAttribute('data-cart-item-quantity');
      var url = lineItem.getAttribute(attributes.cartItemUrl);
      var title = lineItem.getAttribute(attributes.cartItemTitle);

      return theme.strings.removedItemMessage
        .replace('[quantity]', quantity)
        .replace(
          '[link]',
          '<a ' +
            'href="' +
            url +
            '" class="text-link text-link--accent">' +
            title +
            '</a>'
        );
    },



    _emptyCart: function() {
      this.emptyPageContent =
        this.emptyPageContent ||
        this.container.querySelector(selectors.emptyPageContent);

      this.cartWrapper =
        this.cartWrapper || this.container.querySelector(selectors.cartWrapper);

      this.emptyPageContent.classList.remove(classes.hide);
      this.cartWrapper.classList.add(classes.hide);
    },

    upgradeBrightness: {
      selectors: {
          popup: '[data-upbrightness]',
          optionWrapper: '[data-upbrightness-option]',
          option: '[data-upbrightness-option]',
          explanation: '[data-upbrightness-explanation]',
          explanationText: '[data-upbrightness-explanation-text]',
          priceOriginal: '[data-upbrightness-original-price]',
          priceDiscounted: '[data-upbrightness-discounted-price]',
          optionButton: '[data-upbrightness-option-button]',

      },
      container: null,

      baseUrl: window.baseUrl,
      upgradeVariantCount: 0,

      init: function (cartInstance) {
        this.cartInstance = cartInstance;

        this.cartItemsCount = window.cart.cartItemsCount;
        this.product = window.cart.product.product;
        this.lastCartItem = window.cart.lastCartItem;
        this.lastCartItemIndex = window.cart.lastCartItemIndex;
        this.lastProductHash = window.cart.lastProductHash;
        this.variantNameMapping = window.cart.variantNameMapping;

        this.currentPrice = window.cart.lastCartItem.price;
        this.selectedVariantId = window.cart.lastCartItem.id;
        this.variants = window.cart.product.variants;

        if (typeof ga !== 'function') {
          ga = function () {}
        }

        this.container = document.querySelector(this.selectors.popup);
        this.optionWrapper = document.querySelector(this.selectors.optionWrapper);

        this.optionTemplate = this.container.querySelector(this.selectors.option).cloneNode(true);

         console.log('Option Template:', this.optionTemplate);
        setTimeout(function () {
          this.processShowPopup();
        }.bind(this), 500);
      },

  

      _request: function (url, data) {
        return fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(data),
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            throw error;
          }
          return new Promise(function (resolve) {
            resolve(json);
          });
        }).catch(function (error) {
          console.log(error);
        });
      },

      getData: function (hashId, handle, variantFromId, variantToId) {
        return this._request('https://api.celestial-register.com/shopify/' + STAR_APP.name + '/upgrade-brightness/' + hashId, {
          handle,
          currencyCode: Shopify.currency.active,
          variantFromId,
          variantToId
        });
      },

      addVariant: function (variantId, data) {
        this.lastCartItem.properties['_custom_data'] = data;

        return this._request('/cart/add.js', {
          items: [
            {
              quantity: this.lastCartItem.quantity,
              id: variantId,
              properties: this.lastCartItem.properties
            },
          ],
        });
      },

      /**
       * Swaps the star line for the upgraded variant. Extras the configurator (or the
       * cart's "+ Add") nested under the star (parent_relationship) are removed by Shopify
       * together with their parent line, so they are re-added under the new star line
       * before the old one is removed. Extras linked only via _parent stay untouched.
       */
      swapStarLine: function (variantId, data) {
        var self = this;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var oldKey = this.lastCartItem.key;
        // signed 50% discount from srf-api, verified by the CheckoutBanner app's discount Function
        var properties = Object.assign({}, this.lastCartItem.properties);
        delete properties._custom_data;
        delete properties._upgrade_discount;
        if (data && data.upgradeDiscount) properties._upgrade_discount = data.upgradeDiscount;
        var nestedExtras = [];
        var post = function (path, body) {
          return fetch(root + path, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          }).then(function (response) {
            if (!response.ok) throw new Error(path + ' ' + response.status);
            return response.json();
          });
        };
        var readdExtras = function (newKey, nested) {
          return post('cart/add.js', {
            items: nestedExtras.map(function (item) {
              var line = { id: item.variant_id, quantity: item.quantity, properties: item.properties };
              if (nested) line.parent_line_key = newKey;
              return line;
            })
          });
        };

        return fetch(root + 'cart.js')
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            nestedExtras = cart.items.filter(function (item) {
              return item.parent_relationship && item.parent_relationship.parent_key === oldKey;
            });
            return post('cart/add.js', {
              items: [{ id: variantId, quantity: self.lastCartItem.quantity, properties: properties }]
            });
          })
          .then(function (added) {
            if (!nestedExtras.length) return;
            var newKey = added.items[0].key;
            return readdExtras(newKey, true).catch(function () { return readdExtras(newKey, false); });
          })
          .then(function () {
            return post('cart/change.js', { id: oldKey, quantity: 0 });
          });
      },

      removeVariant: function (cb) {
        // TODO: callback (cb) to promises
        var request = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;'
          },
          body: JSON.stringify({
            line: this.lastCartItemIndex + 1,
            quantity: 0
          })
        };

        return this.cartInstance._changeJsRequest(request, function (state) {
          
          cb(state);
          // Reload the page after upgrading the brightness
          document.body.classList.remove('loading');
          this._fetchUpdatedCartItems();
          console.log('Fetch inside removeVariant')
          
        }.bind(this));
      },

      getVariantTitle: function (variant) {
        var title = variant.variant.title,
            id = variant.variant.id;
        try {
          return window.cart.variantNameMapping[id].name;
        } catch (e) {
          return 'Upgrade to ' + title;
        }
      },

      buildOption: function (variant) {
        var self = this;
        var priceDiff = variant.variant.price - this.currentPrice,
            priceDiffDiscounted = priceDiff / 2,
            priceDiffFormatted = theme.Currency.formatMoney(
                priceDiff,
                theme.moneyFormat
            ),
            priceDiffDiscountedFormatted = theme.Currency.formatMoney(
                priceDiffDiscounted,
                theme.moneyFormat
            );

        var option = this.optionTemplate.cloneNode(true);
        console.log('Option' + option);
        var explanationText = option.querySelector(this.selectors.explanationText);
        var originalPrice = option.querySelector(this.selectors.priceOriginal);
        var discountedPrice = option.querySelector(this.selectors.priceDiscounted);
 
         if (!discountedPrice) {
      console.error('Discounted Price element not found');
    } else {
      console.log('Discounted Price element:', discountedPrice);
     
    }
        var button = option.querySelector(this.selectors.optionButton);

        button.addEventListener('click', function () {

          if (variant.brightness === 1) {
            ga('send', 'event', 'Upgrade', 'click', 'upgrade_bright');
          } else if (this.upgradeVariantCount === 1) {
            ga('send', 'event', 'Upgrade', 'click', 'upgrade_bright_verybright');
          } else if (variant.brightness === 2) {
            ga('send', 'event', 'Upgrade', 'click', 'upgrade_verybright');
          }

          setTimeout(function () {
            self.container.classList.add('loading');
          }, 200);
          var lastItem = window.cart.lastCartItem;

          self.getData(
              lastItem.properties._hash,
              lastItem.handle,
              lastItem.variant_id,
              variant.variant.id
          ).then(function (data) {
            // srf-api didn't answer: keep the star as it is rather than charging the full price
            if (!data || typeof data !== 'object' || !('upgradeDiscount' in data)) {
              self.container.classList.remove('loading');
              self.container.classList.remove('visible');
              console.error('[Cart] brightness upgrade: no answer from srf-api');
              return;
            }

            self.swapStarLine(variant.variant.id, data)
              .then(function () {
                theme.Helpers.setCookie('last-brightness-upsell-hash', window.cart.lastProductHash);
                theme.Helpers.setCookie('last-brightness-upsell-variant', variant.variant.id);
                theme.Helpers.setCookie('last-brightness-upsell-count', self.upgradeVariantCount);
                self.container.classList.remove('visible');
                document.body.classList.remove('loading');
                self.cartInstance._fetchUpdatedCartItems();
              })
              .catch(function (error) {
                console.error('[Cart] brightness upgrade failed', error);
                window.location.reload();
              });
          });
        });

        var title = this.getVariantTitle(variant);
      
        originalPrice.innerText = '(+' + priceDiffFormatted + ')';
        discountedPrice.innerText = '(+' + priceDiffDiscountedFormatted + ')';
        button.innerHTML = title;
        return option;
      },

      closePopup: function () {
        ga('send', 'event', 'Upgrade', 'click', 'close_brightness');
        theme.Helpers.setCookie('last-brightness-upsell-hash', window.cart.lastProductHash);
        theme.Helpers.setCookie('last-brightness-upsell-count', this.upgradeVariantCount);
        this.container.classList.remove('visible');
      },

      shouldShowUpgradeOptions: function () {
        if (window.cart.cartItemsCount < 1 || window.cart.product.type === "Gift Card") {
          return false;
        }
        return theme.Helpers.getCookie('last-brightness-upsell-hash') != window.cart.lastProductHash ||
            theme.Helpers.getCookie('last-brightness-upsell-variant') != window.cart.lastCartItem.variant_id;
      },

      processShowPopup: function () {
        if (!this.shouldShowUpgradeOptions()) {
          // should not show popup, since it is already shown
          return;
        }
        var upgradeVariants = [],
            brightness = 0;
        for (var i = 0; i < this.variants.length; i++) {
          var variant = this.variants[i];
          if (variant.price > this.currentPrice) {
            upgradeVariants.push({brightness, variant});
          }
          brightness++;
        }

        this.upgradeVariantCount = upgradeVariants.length;

        if (this.upgradeVariantCount && (this.upgradeVariantCount <= theme.Helpers.getCookie('last-brightness-upsell-count', 100) || theme.Helpers.getCookie('last-brightness-upsell-hash') != this.lastProductHash)) {
            this.optionWrapper.innerHTML = '';
            for (var j = 0; j < this.upgradeVariantCount; j++) {
            var option = this.buildOption(upgradeVariants[j]);
            this.optionWrapper.appendChild(option);
          }

          this.container.classList.add('visible');
        }

        this.container.querySelector('.cancel').addEventListener('click', this.closePopup.bind(this));
        this.container.querySelector('.close').addEventListener('click', this.closePopup.bind(this));
        theme.Helpers.setCookie('last-brightness-upsell-variant', this.lastCartItem.variant_id);
      }
    },

    discount: {
      selectors: {
        discountWrapper: '.cart-discount__wrapper',
        codeInput: '[data-discount-value]',
        btn: '[data-discount-apply]',
        remove: '[data-discount-remove]',
        codeName: '[data-discount-name]',
        codeValue: '[data-discount-value]',
        codePercentage: '[data-discount-percentage]',
        details: '[data-discount-details]',
      },

      init: function (cartInstance) {
        this.cartInstance = cartInstance;
        this.loading = false;
        this.container = this.cartInstance.container;
        this.discountWrapper = this.container.querySelector(this.selectors.discountWrapper);
        this.form = this.container.querySelector('form.cart');
        this.input = document.querySelector(this.selectors.codeInput);
        this.btn = document.querySelector(this.selectors.btn);
        this.remove = document.querySelectorAll(this.selectors.remove);
        this.details = document.querySelector(this.selectors.details);
        this.baseUrl = window.location.protocol + "//" + window.location.hostname;
        this.subtotal = this.container.querySelector('[data-cart-subtotal]');

        this.codeNameEls = this.container.querySelectorAll(this.selectors.codeName);
        this.codeValueEls = this.container.querySelectorAll(this.selectors.codeValue);
        this.codePercentageEls = this.container.querySelectorAll(this.selectors.codePercentage);
        var self = this;
       
        this.btn.addEventListener('click', function () {
          self.applyDiscount(self.input.value);
        });
        

        this.remove.forEach(function(el) {
          el.addEventListener('click', function (e) {
            e.preventDefault();
            self.removeDiscountHiddenInput();
            self.render();
            return false;
          });
        });

        this.current = {error: false};

        var observer = new MutationObserver(function () {
          if (this.shouldUpdate && this.current) {
            this.applyDiscount(this.current.code);
          }
          this.current = {subtotalVal: this.currentSubtotal};
        }.bind(this));

        observer.observe(this.subtotal, {attributes: true, childList: true, subtree: true});

        this.render();
      },

      getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },

      get current() {
        var data = JSON.parse(localStorage.getItem('tinydiscount'));
        return (data && data.sessionId === this.getCookie("__ssid")) ? data : null;
      },

      set current(data) {
        if (data !== null && this.current) {
          data = Object.assign(this.current, data);
        }
        if (!data) {
          data = {};
        }
        data.sessionId = this.getCookie("__ssid");
        localStorage.setItem('tinydiscount', JSON.stringify(data))
      },

      get currentSubtotal() {
        return this.subtotal.innerHTML;
      },

      get loading() {
        return !!JSON.parse(localStorage.getItem('tinydiscountloading'));
      },

      set loading(loading) {
        localStorage.setItem('tinydiscountloading', loading ? true : null);
      },

      get shouldUpdate() {
        return this.loading || !this.current ? false : this.current.subtotalVal !== this.currentSubtotal;
      },

      request: function (url, requestType = "json", method = "GET", data = null) {
        return new Promise(function (resolve, reject) {
          var req = new XMLHttpRequest();
          var randomString = Math.random().toString(36).substr(2, 10);

          method === 'GET' && (url += '?' + randomString);

          req.open(method, url, true);
          req.responseType = requestType;
          if (requestType === 'json') {
            req.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
          }

          req.onload = function () {
            req.status === 200 ? resolve(req) : reject(req);
          };

          req.send(data ? JSON.stringify(data) : null);
        })
      },

      getCodeDataFromCheckout: function () {
        return this.request(this.baseUrl + '/checkout', "text").then(function (response) {
          var doc = (new DOMParser()).parseFromString(response.responseText, 'text/html');
          var attr = function (attribute) {
            var el = doc.querySelector('[' + attribute + ']');
            if (el) {
              return parseFloat(el.getAttribute(attribute))
            }
          };
          var codeEl = doc.querySelector("span.reduction-code .reduction-code__text");
          if (!codeEl) {
            return false;
          }
          var code = codeEl.innerHTML.trim(),
              discount = attr("data-checkout-discount-amount-target"),
              shipping = attr("data-checkout-total-shipping-target"),
              subtotal = attr("data-checkout-subtotal-price-target") - shipping;

          if (!discount && subtotal === 0) {
            return this.request(this.baseUrl + '/cart.js').then(function (data) {
              subtotal = data.response.total_price;
              discount = subtotal;
              return {code, discount, shipping, subtotal};
            }.bind(this));
          } else {
            return {code, discount, shipping, subtotal};
          }
        }.bind(this));
      },

      addDiscountHiddenInput: function (code) {
        var n = document.createElement("input");
        n.setAttribute("type", "hidden");
        n.setAttribute("name", "discount");
        n.value = code;
        this.form.insertAdjacentElement("afterbegin", n);
      },

      removeDiscountHiddenInput: function () {
        document.querySelectorAll('input[name="discount"]').forEach(function(t) {
          t.remove();
        });
        var data = this.current;
        if (data && data.code) {
          data.code = false;
          data.discount = false;
          this.current = data;
        }
      },

      render: function () {
        var data = this.current;
        var subtotalEl = this.container.querySelector(selectors.cartSubtotal);
        var subtotalDiscountedEl = this.container.querySelector(selectors.cartSubtotalDiscounted);
        if (data && data.code && data.discount) {
          this.codeNameEls.forEach(function(item) {item.innerHTML = data.code});
          this.codeValueEls.forEach(function (item) {
            item.innerHTML = "- " + theme.Currency.formatMoney(data.discount, theme.moneyFormat);
          });
          var percentage = Math.round(data.discount / data.subtotal * 100);
          this.codePercentageEls.forEach(function (item) {
            item.innerHTML = "- " + percentage + "%";
          });
          subtotalDiscountedEl.textContent = theme.Currency.formatMoney(data.subtotal - data.discount, theme.moneyFormat);
          subtotalEl.classList.add('discount-used');
          subtotalDiscountedEl.classList.remove('hide');
          this.details.classList.remove('hide');
          this.addDiscountHiddenInput(data.code);
          this.discountWrapper.classList.add('applied');
        } else {
          subtotalEl.classList.remove('discount-used');
          subtotalDiscountedEl.classList.add('hide');
          this.details.classList.add('hide');
          this.removeDiscountHiddenInput();
          this.discountWrapper.classList.remove('applied');
        }

        if (data && data.error) {
          this.discountWrapper.classList.add('error');
        } else {
          this.discountWrapper.classList.remove('error');
        }

        this.input.value = '';
      },

      applyDiscount: function (code) {
        if (!code) {
          this.render();
          return;
        }
        var applyCodeUrl = this.baseUrl + '/discount/' + code;
        this.btn.classList.add('loading');
        this.loading = true;

        this.request(applyCodeUrl, "text", "HEAD").then(function () {
          return this.getCodeDataFromCheckout();
        }.bind(this)).then(function (data) {
          if (!data.code || code.toUpperCase() !== data.code.toUpperCase()) {
            this.current = {error: true}
          } else {
            this.current = data;
            this.current = {error: false}
          }
          this.render();
          this.btn.classList.remove('loading');
          this.loading = false;
        }.bind(this));
      }
    }, 
  });

  return Cart;
})();